<!--
  UncoveredColorsMarker -- warns that a product has colors NO placement
  decorates (Jake, 2026-10-22). Orders for those colors go out as blank
  goods, so the distributor sees it wherever the product is listed (card and
  products table) instead of finding out at the decorator. Warn-only: it is
  an icon with an accessible name, never a gate.

  `count` is the server's `uncovered_color_count` from the products readiness
  rollup (variant_resolver.uncovered_color_skus owns the definition). Renders
  nothing for 0 / missing, so a fully covered product is untouched.
-->
<template>
  <span
    v-if="n > 0"
    :data-testid="testid"
    class="uncovered-colors-marker"
    role="img"
    :title="label"
    :aria-label="label"
  >
    <span class="material-icons uncovered-colors-marker__icon" aria-hidden="true"
      >warning</span
    >
    <!-- Marker's own text: lets a scenario name THIS marker, not any icon. -->
    <span class="uncovered-colors-marker__text">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  count: { type: Number, default: 0 },
  testid: { type: String, default: "uncovered-colors-marker" },
});

const n = computed(() => (Number.isFinite(props.count) ? props.count : 0));
const label = computed(
  () =>
    `${n.value} ${n.value === 1 ? "color has" : "colors have"} no placement. ` +
    "Orders for " +
    `${n.value === 1 ? "it" : "them"} are produced without a decoration.`,
);
</script>

<style scoped>
.uncovered-colors-marker__text {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.uncovered-colors-marker__icon {
  font-size: 20px;
  line-height: 1;
  color: #b25e00;
  vertical-align: middle;
}
</style>
